export function formatPhoneNumber(phoneNumber: string | number): string {
	const digits = String(phoneNumber).replace(/\D/g, "");

	if (digits.length !== 8 && digits.length !== 7) {
		return String(phoneNumber);
	}

	if (digits.startsWith("4") || digits.startsWith("9")) {
		return `${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5)}`;
	}

	return `${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4, 6)} ${digits.slice(6)}`;
}
